import { useMutation, useQueryClient } from '@tanstack/react-query';
import { packagesService, TrainerPackage } from '../services/packagesService';
import { trainerPackagesQueryKey } from '../queries/useGetTrainerPackages';

export interface UnpublishPackagePayload {
  trainerId: string;
  packageId: string;
}

export function useUnpublishTrainerPackage() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UnpublishPackagePayload>({
    mutationFn: async ({ trainerId, packageId }) => {
      return packagesService.unpublishTrainerPackage(trainerId, packageId);
    },
    onSuccess: (_, variables) => {
      const qKey = trainerPackagesQueryKey(variables.trainerId);

      // Hydrate query cache immediately
      queryClient.setQueryData<TrainerPackage[]>(qKey, (oldList = []) => {
        return oldList.map((p) =>
          p.id === variables.packageId ? { ...p, status: 'draft' as const } : p,
        );
      });

      queryClient.invalidateQueries({ queryKey: qKey });
    },
  });
}
